import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import ActionButton from './action_button';
import { monsterAt } from '../utils/combat/monsters';
import { playSound } from '../utils/audio';
import { canStepOnto } from '../utils/viewMath';

function compassToModifier(compass){
    const gridModifier = {
        '0':[0,-1],
        '90':[-1,0],
        '180':[0,1],
        '270':[1,0],
    }
    return gridModifier[compass]
}

function compassToModifierLR(compass){
  const gridModifier = {
      '0':[-1,0],
      '90':[0,1],
      '180':[1,0],
      '270':[0,-1],
  }
  return gridModifier[compass]
}

class ControlArrows extends Component {

  componentDidMount(){
    window.addEventListener('keydown', (e)=>this.useKeypress(e));
  }

  componentWillUnmount(){
    window.removeEventListener("keydown", (e)=>this.useKeypress(e));
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.context.player_coords === this.props.context.player_coords) return;
    // Nothing triggers on its own any more: say what is here, and let the
    // player use it with F (or the USE button)
    this.props.context.describeHere();
    // Must run last: it uses a functional update so it sees the message above
    this.props.context.advanceWorld(prevProps.context.player_coords);
  }

  // Movement is frozen while fighting, casting, animating, or after the party has fallen
  movementLocked = () => {
    const { combat, gameOver, busy, spellcasting, characterSheet, screen, facility, mapOpen, gameMenuOpen } = this.props.context;
    return !!(combat || gameOver || busy || spellcasting || characterSheet !== null || screen !== 'playing' ||
              facility || mapOpen || gameMenuOpen);
  }

  // Turning is still allowed in combat (enemies stay lined up in view)
  turningLocked = () => {
    const { gameOver, busy, characterSheet, screen, facility, mapOpen, gameMenuOpen } = this.props.context;
    return !!(gameOver || busy || characterSheet !== null || screen !== 'playing' || facility || mapOpen || gameMenuOpen);
  }

  isBlockedByMonster = ([x, y]) => {
    return !!monsterAt(this.props.context.monsters, x, y);
  }
  
  useKeypress = (e) => {
    const { characterSheet, facility, mapOpen, spellcasting, gameMenuOpen, openCharacterSheet, party } = this.props.context;
    // 1-6 opens a character's sheet, unless a menu is already using those keys
    const slot = parseInt(e.key, 10) - 1;
    if (slot >= 0 && slot < party.length &&
        characterSheet === null && !facility && !mapOpen && !spellcasting && !gameMenuOpen) {
      openCharacterSheet(slot);
      return;
    }
    if (e.key === 'm' || e.key === 'M') {
      this.props.context.toggleMap();
      return;
    }
    // Arrow keys always turn; letter keys are combat commands while fighting
    // (A = Attack), so A/D only turn when free to move
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      if (e.key === 'ArrowRight') this.turnRightClick(null); else this.turnLeftClick(null);
      return;
    }
    if (this.movementLocked()) return;
    if(e.key === 'd' || e.key === 'D'){
      this.turnRightClick(null);
    } else if (e.key === 'a' || e.key === 'A'){
      this.turnLeftClick(null);
    } else if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W'){
      this.forwardClick(null);
    } else if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S'){
      this.backwardsClick(null);
    } else if (e.key === 'q' || e.key === 'Q'){
      this.leftClick(null);
    } else if (e.key === 'e' || e.key === 'E'){
      this.rightClick(null);
    } else if (e.key === 'f' || e.key === 'F'){
      this.props.context.interact();
    } else if (e.key === 'b' || e.key === 'B'){
      this.props.context.bashDoor();
    } else if (e.key === 'x' || e.key === 'X'){
      this.props.context.shoot();
    } else if (e.key === 'c' || e.key === 'C'){
      this.props.context.beginCast();
    }
  }
  
  actionClick = (button) => {
    this.props.context.update({
      eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}]
    })
  }

  forwardClick = (button) => {
    if (this.movementLocked()) return;
    let modifer = compassToModifier(this.props.context.player_heading);
    let currentCoords = this.props.context.player_coords;
    let newCoords = [currentCoords[0] + modifer[0], currentCoords[1] + modifer[1]];

    const tileValue = this.props.context.player_map[newCoords[1]][newCoords[0]];
    if(!canStepOnto(tileValue) || this.isBlockedByMonster(newCoords)){
      newCoords = currentCoords;
    }

    playSound(newCoords === currentCoords ? 'bump' : 'step');
    this.props.context.update({
      //eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}],
      player_coords: newCoords
    })
  }

  backwardsClick = (button) => {
    if (this.movementLocked()) return;
    let modifer = compassToModifier(this.props.context.player_heading);
    let currentCoords = this.props.context.player_coords;
    let newCoords = [currentCoords[0] + (modifer[0] * -1), currentCoords[1] + (modifer[1] * -1)];

    const tileValue = this.props.context.player_map[newCoords[1]][newCoords[0]];
    if(!canStepOnto(tileValue) || this.isBlockedByMonster(newCoords)){
      newCoords = currentCoords;
    }

    playSound(newCoords === currentCoords ? 'bump' : 'step');
    this.props.context.update({
      //eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}],
      player_coords: newCoords
    })
  }

  leftClick = (button) => {
    if (this.movementLocked()) return;
    let modifer = compassToModifierLR(this.props.context.player_heading);
    let currentCoords = this.props.context.player_coords;
    let newCoords = [currentCoords[0] + (modifer[0]), currentCoords[1] + (modifer[1])];

    const tileValue = this.props.context.player_map[newCoords[1]][newCoords[0]];
    if(!canStepOnto(tileValue) || this.isBlockedByMonster(newCoords)){
      newCoords = currentCoords;
    }

    playSound(newCoords === currentCoords ? 'bump' : 'step');
    this.props.context.update({
      //eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}],
      player_coords: newCoords
    })
  }

  rightClick = (button) => {
    if (this.movementLocked()) return;
    let modifer = compassToModifierLR(this.props.context.player_heading);
    let currentCoords = this.props.context.player_coords;
    let newCoords = [currentCoords[0] + (modifer[0] * -1), currentCoords[1] + (modifer[1] * -1)];

    const tileValue = this.props.context.player_map[newCoords[1]][newCoords[0]];
    if(!canStepOnto(tileValue) || this.isBlockedByMonster(newCoords)){
      newCoords = currentCoords;
    }

    playSound(newCoords === currentCoords ? 'bump' : 'step');
    this.props.context.update({
      //eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}],
      player_coords: newCoords
    })
  }

  turnRightClick = (button) => {
    if (this.turningLocked()) return;
    playSound('turn');
    let rightCompass = (parseInt(this.props.context.player_heading) - 90 < 0) ? 270 : this.props.context.player_heading - 90;

    this.props.context.update({
      player_heading: rightCompass,
    })
  }

  turnLeftClick = (button) => {
    if (this.turningLocked()) return;
    playSound('turn');
    let leftCompass = (parseInt(this.props.context.player_heading) + 90 === 360) ? 0 : this.props.context.player_heading + 90;

    this.props.context.update({
      player_heading: leftCompass,
    })
  }

  render() {
    return (
      <div id="controlArrows">
        <ActionButton classes={['arrow']} alt="TURN LEFT" icon="arrow_turn" actionClick={this.turnLeftClick} />
        <ActionButton classes={['arrow']} alt="FORWARD" icon="arrow_forward" actionClick={this.forwardClick} />
        <ActionButton classes={['arrow']} alt="TURN RIGHT" icon="arrow_turn" turn="flip" actionClick={this.turnRightClick} />
        <ActionButton classes={['arrow']} alt="LEFT" icon="arrow_forward" turn="rot-270" actionClick={this.leftClick} />
        <ActionButton classes={['arrow']} alt="BACKWARD" icon="arrow_forward" turn="rot-180" actionClick={this.backwardsClick} />
        <ActionButton classes={['arrow']} alt="RIGHT" icon="arrow_forward" turn="rot-90" actionClick={this.rightClick} />
      </div>
    );
  }
}

export default withContext(ControlArrows);